import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function CourseRequirements() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3032">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3033">
        <div className="mb-12" data-id="element-3034">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3035">
            Course Requirements
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3036">
            <p className="text-base text-gray-800 mb-6 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3037">
              This course is for candidates who are 21 years or older and have
              experience and familiarity with both handguns and long guns.
            </p>
            <ul className="space-y-4" data-id="element-3038">
              {['Candidates will be required to participate in classroom exercises', 'Candidates will be required to conduct public speaking exercises', 'Candidates must take and pass a multiple choice exam', 'Candidates must meet all course objectives and pass the exam to be eligible for certification'].map((req, index) => <li key={index} className="flex items-start gap-3" data-id="element-3039">
                  <CheckCircleIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                color: '#1e3d2f'
              }} data-id="element-3040" />
                  <span className="text-base text-gray-800" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-3041">
                    {req}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}